import React, { useState, useEffect } from "react";
import agentImg from "../images/Customer/A1.jpg"
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { createLoanEnquiry, resetState } from "../features/loanEnq/loanEnqSlice";
import { DotPulse } from "ldrs/react";
import "ldrs/react/DotPulse.css";

const LoanApplication = ({ slug, title }) => {
  const dispatch = useDispatch();

  const { isSuccess, isError, message, isLoading } = useSelector(
    (state) => state.loanEnquiry
  );

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    loanType: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const enquiryData = {
      ...formData,
      slug,
      title,
    };

    dispatch(createLoanEnquiry(enquiryData));
  };

  // ✅ Handle success/error feedback
  useEffect(() => {
    if (isSuccess) {
      toast.success("Loan enquiry submitted successfully!");
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        loanType: "",
        message: "",
      });
      dispatch(resetState());
    }
    if (isError) {
      toast.error(message || "Something went wrong, please try again!");
    }
  }, [isSuccess, isError, message, dispatch]);

  return (
    <div className="loan-application-container">
      {/* Left Column - Agent Info */}
      <div className="agent-info">
        <img src={agentImg} alt="Agent" className="agent-img" />
        <h3>Peace Doyle</h3>
        <p>Sales Admin</p>
        <p>Helping you get the best financing for your dream car.</p>

        <div className="agent-actions">
          <a href="tel:+254713988888" className="agent-btn call-btn">
            <FaPhoneAlt /> +254 713 988 888
          </a>
          <a
            href="https://wa.me/254713988888"
            target="_blank"
            rel="noopener noreferrer"
            className="agent-btn whatsapp-btn"
          >
            <FaWhatsapp className="loan__whatsapp-icon" /> Start a Chat
          </a>
        </div>
      </div>

      {/* Right Column - Loan Application Form */}
      <div className="loan-form-wrapper">
        <h2>Loan Application Form</h2>
        {title && (
          <p className="car-info mb-3">
            Applying for: <strong>{title}</strong>
          </p>
        )}
        <form className="loan-form" onSubmit={handleSubmit}>
          <div className="form__group-container">
            <div className="form-group">
              <label>Full Name</label>
              <input
                name="fullName"
                type="text"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
                required
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>
              <input
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                required
              />
            </div>

            <div className="form-group">
              <label>Loan Type</label>
              <select
                name="loanType"
                value={formData.loanType}
                onChange={handleChange}
                required
              >
                <option value="">Select Loan Type</option>
                <option value="Salaried Loan">Salaried Loan</option>
                <option value="Business Loan">Business Loan</option>
              </select>
            </div>
          </div>

          <div className="form-group full-width">
            <label>Additional Message (Optional)</label>
            <textarea
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              placeholder="Write any extra information here..."
            ></textarea>
          </div>

          <button type="submit" className="submit-btn" disabled={isLoading}>
            {isLoading ? (
              <>
                
                <span >Processing <DotPulse size="35" speed="1.2" color="white" /></span>
              </>
            ) : (
              "Submit Application"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoanApplication;
